import React, { FC, useState, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import Paper from '@mui/material/Paper';
import makeStyles from '@mui/styles/makeStyles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { TabPanel, Loader } from 'ui';
import { SettingsTab } from './SettingsTab';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(3, 2),
    backgroundColor: theme.palette.background.paper,
  },
}));

const tabsLabelsIds = {
  systemUpdate: 'system_update',
  accountNotification: 'account_notification',
  response: 'response',
  whatsNew: 'whats_new',
};

const tabsLabels = [
  {
    label: 'System notifications',
    id: tabsLabelsIds.systemUpdate,
  },
  {
    label: 'Account updates',
    id: tabsLabelsIds.accountNotification,
  },
  {
    label: 'Responses',
    id: tabsLabelsIds.response,
  },
  {
    label: "What's new",
    id: tabsLabelsIds.whatsNew,
  },
];

export type SettingsData = {
  category: string;
  description: string;
  frequency: string;
  id: string;
  name: string;
  isEmail: boolean;
  isPush: boolean;
};

type SettingsProps = {
  onNotificationsSettingsChange: () => void;
  isLoading: boolean;
  settings: any;
};

const Settings: FC<SettingsProps> = ({ onNotificationsSettingsChange, settings, isLoading }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const availableTabsLabels = settings
    ? tabsLabels.filter(({ id }) => Object.keys(settings).includes(id))
    : [];

  const handleChange = (event: ChangeEvent<{}>, newValue: any) => {
    setValue(newValue);
  };

  return (
    <Paper className={classes.root}>
      {isLoading ? (
        <Loader center />
      ) : (
        <>
          <Tabs value={value} onChange={handleChange}>
            {availableTabsLabels.map(({ label, id }) => (
              <Tab key={id} label={t(label)} />
            ))}
          </Tabs>
          {availableTabsLabels.map(({ id }, index) => (
            <TabPanel key={id} value={value} index={index}>
              <SettingsTab
                data={settings[id] as Array<SettingsData>}
                onChange={onNotificationsSettingsChange}
              />
            </TabPanel>
          ))}
        </>
      )}
    </Paper>
  );
};

export { Settings };
